import { useLocation } from '@namespace/i18n';
import { PROVIDER_HEADER_TYPE } from '../../constants';

export const useGetNavItemAction = ({ isActionLink, link }) => {
  const { pathname } = useLocation();

  const actionType = link.split(':')[1]?.split('/')[0];

  if (!isActionLink) {
    return { link };
  }

  switch (actionType) {
    case PROVIDER_HEADER_TYPE.SMARTICO: {
      return {
        link: `${pathname}?sFrame=${link.split(':')[1]}`
      };
    }
    default:
      return { link };
  }
};
